"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "random/5.0.2";
//# sourceMappingURL=_version.js.map